import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e37db75"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 10px 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { style: {"flex":"1","overflow":"auto","display":"flex","padding":"0 24px 8px 24px"} }
const _hoisted_4 = { class: "employeeName" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["innerHTML"]

import { computed, onMounted, PropType, reactive, ref, watch } from 'vue'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import { getRegionTargetCompletion } from '@/api/gucangSales/regionDataBoard'
import dayjs from 'dayjs'
import riseImage from '@/assets/rise.png'
import declineImage from '@/assets/decline.png'


const __default__ = {
  name: 'RegionTargetCompletionList'
}

interface ApiModel {
  salesAmount?: number, // 当月新客收入
  lastSalesAmount?: number, // 上月新客收入
  momInc?: number, // 新客环比增量
  momRate?: string, // 新客环比上月%
  salesAmountTotal?: number, // 当月总收入
  lastSalesAmountTotal?: number, // 上月总收入
  oldSalesAmount?: number, // 当月老客收入
  lastOldSalesAmount?: number, // 上月老客收入
  oldMomInc?: number, // 老客环比上月增量
  oldMomRate?: string, // 老客环比上月%
}

interface ItemModel {
  employeeName?: string // 员工名称
  employeeNo?: string, // 员工工号
  data?: ApiModel
}

interface QueryFormType {
  customerRegionEmployeeNoList?: string[]
  startDay?: string
  endDay?: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '目标完成情况'
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props
const listColumns = computed(() => {
  return [
    {
      title: '业务员',
      dataIndex: 'employeeName'
    },
    {
      title: '当月新客收入',
      dataIndex: ['data', 'salesAmount']
    },
    {
      title: '环比上月增量',
      dataIndex: ['data', 'momInc']
    },
    {
      title: '环比上月%',
      dataIndex: ['data', 'momRate']
    },
    {
      title: '当月老客收入',
      dataIndex: ['data', 'oldSalesAmount']
    },
    {
      title: '环比上月增量',
      dataIndex: ['data', 'oldMomInc']
    },
    {
      title: '环比上月%',
      dataIndex: ['data', 'oldMomRate']
    }
  ]
})
const tableData = ref<ItemModel[]>([])
onMounted(() => {
  getData()
})
watch(() => props.formState, (val) => {
  queryForm.customerRegionEmployeeNoList = props?.formState?.customerRegionEmployeeNoList || []
  queryForm.startDay = props?.formState?.startDay || dayjs().startOf('month').format('YYYY/MM/DD')
  queryForm.endDay = props?.formState?.endDay || dayjs().endOf('month').format('YYYY/MM/DD')
  getData()
})
const queryForm = reactive<QueryFormType>({
  startDay: props?.formState?.startDay || dayjs().startOf('month').format('YYYY/MM/DD'),
  endDay: props?.formState?.endDay || dayjs().endOf('month').format('YYYY/MM/DD'),
  customerRegionEmployeeNoList: props?.formState?.customerRegionEmployeeNoList || []
})
const getData = () => {
  getRegionTargetCompletion(queryForm).then((res) => {
    const salesAmountList = res.data as unknown as ApiModel[]
    const transferredData: any[] = []
    props.formState?.region?.deptScopeInfo.forEach((employee: any) => {
      if (employee) {
        transferredData.push({
          employeeName: employee.employeeName,
          employeeNo: employee.employeeNo,
          data: salesAmountList?.find((item) => {
            return item.employeeNo === employee.employeeNo
          })
        })
      }
    })
    tableData.value = transferredData
  }).finally(() => {
  })
}
const imageByCompare = (num1: number, num2: number) => {
  if (num1 > num2) {
    return '<img src="' + riseImage + '" class="icon icon-right" alt="" />'
  } else if (num1 < num2) {
    return '<img src="' + declineImage + '" class="icon icon-right" alt="" />'
  } else {
    return ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CosTable, {
        columns: listColumns.value,
        needPage: false,
        dataSource: tableData.value,
        serial: false,
        rowKey: "employeeNo",
        tableId: "regionTargetCompletionTable",
        dynamicColumnSetting: false
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.dataIndex === 'employeeName')
            ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text || '--'), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(text || '--'), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.dataIndex?.[0] === 'data' && column.dataIndex?.[1] === 'momRate')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(text || '--') + " ", 1),
                _createElementVNode("span", {
                  innerHTML: imageByCompare(record.data?.salesAmount, record.data?.lastSalesAmount)
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex?.[0] === 'data' && column.dataIndex?.[1] === 'oldMomRate')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(text || '--') + " ", 1),
                _createElementVNode("span", {
                  innerHTML: imageByCompare(record.data?.oldSalesAmount, record.data?.lastOldSalesAmount)
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "dataSource"])
    ])
  ], 4))
}
}

})